export default __webpack_public_path__ + "static/media/placeholder_business01-en-web.ec1c767c.png";